import { render, staticRenderFns } from "./benefits-banners.vue?vue&type=template&id=70358dd2&scoped=true"
import script from "./benefits-banners.vue?vue&type=script&lang=js"
export * from "./benefits-banners.vue?vue&type=script&lang=js"
import style0 from "./benefits-banners.vue?vue&type=style&index=0&id=70358dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70358dd2",
  null
  
)

export default component.exports